/**
 * Start a browser download for a URL by clicking a transient, hidden anchor.
 *
 * Use this — not `window.open` — when the download is kicked off from an async callback (e.g. a
 * mutation's onSuccess after a network round-trip). A `window.open` call outside the originating
 * click's gesture stack is treated as a popup and silently blocked by the browser, so the download
 * never happens. An anchor click to a URL whose response carries `Content-Disposition: attachment`
 * downloads the file in place without opening a tab and is not popup-blocked.
 *
 * The `download` attribute is intentionally omitted: browsers ignore it for cross-origin URLs
 * (e.g. a presigned S3 link), so the filename comes from the response's Content-Disposition header.
 */
export function downloadFromUrl(url: string): void {
  const link = document.createElement('a');
  link.href = url;
  link.rel = 'noopener noreferrer';
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
